import { DashboardModule, Form, SectionDivider } from '@domain-group/suit-theme'

import handleCallbackAction from '@functions/handleCallbackAction'
import { toggleNestedValue, confirmAction } from '@functions/entity'

import ScopedConditionalContent from '@components/ScopedConditionalContent'
import ToggleListItem from '@components/ToggleListItem'

import type { UsePortalPayload } from '@hooks/usePortal'

import type { PortalModel } from '@models/portal'

const handleSettingsUpdate = (
  entityState: Partial<PortalModel>,
  updatePortal: UsePortalPayload['callbacks']['updatePortal'],
) => {
  const updateSettingsPayload = {
    callbacks: {
      action: updatePortal,
    },
    entityParams: entityState,
    toastText: 'Portal Updated',
  }

  // @ts-expect-error TS2345
  handleCallbackAction(updateSettingsPayload)
}

interface PortalSettingsProps {
  callbacks: {
    updatePortal: UsePortalPayload['callbacks']['updatePortal'],
  },
  portal: PortalModel,
}

const PortalSettings = (props: PortalSettingsProps) => {
  const { callbacks: { updatePortal }, portal } = props

  const {
    import_format,
    export_format,
    options,
  } = portal

  const {
    batched_image_export_enabled,
    export_enabled,
    export_logs_supported,
  } = options || {}

  const bulkImageExportPayload = {
    callbacks: {
      actionFn: () => (
        // @ts-expect-error TS2345
        updatePortal(toggleNestedValue({ entityState: { ...portal } }, 'options.batched_image_export_enabled'))
      ),
    },
    options: {
      icon: 'warning',
    },
    strings: {
      actionString: 'update',
      confirmString: 'Are you sure? This should only be changed to fix rate limiting issues with the Portal (default is \'Off\')',
      entityName: 'portal setting',
    },
  }

  return (
    <DashboardModule title="Portal Settings">
      <Form padding="large">
        <Form.Field label="Import">
          <select
            onChange={e => handleSettingsUpdate(
              { import_format: e.target.value },
              updatePortal,
            )}
            name="import_format"
            value={import_format}
          >
            <option value="">Please Select...</option>
            <option value="reaxml">REAXML</option>
            <option value="json">JSON</option>
          </select>
        </Form.Field>

        <Form.Field label="Export" marginTop="large">
          <select
            onChange={e => handleSettingsUpdate(
              { export_format: e.target.value },
              updatePortal,
            )}
            name="export_format"
            value={export_format}
          >
            <option value="">Please Select...</option>
            <option value="reaxml">REAXML</option>
            <option value="json">JSON</option>
          </select>
        </Form.Field>

        <SectionDivider boxProps={{ marginY: 'large' }}>PORTAL SETTINGS</SectionDivider>

        <ToggleListItem
          onClick={() => handleSettingsUpdate(
            toggleNestedValue({ entityState: { ...portal } }, 'options.export_enabled'),
            updatePortal,
          )}
          // @ts-expect-error TS2322
          toggleValue={export_enabled}
        >
          <ToggleListItem.Title>Enable Export</ToggleListItem.Title>
          <ToggleListItem.Description>
            System can export to the portal
          </ToggleListItem.Description>
        </ToggleListItem>

        <ToggleListItem
          onClick={() => handleSettingsUpdate(
            toggleNestedValue({ entityState: { ...portal } }, 'options.export_logs_supported'),
            updatePortal,
          )}
          // @ts-expect-error TS2322
          toggleValue={export_logs_supported}
        >
          <ToggleListItem.Title>Export Logs Supported</ToggleListItem.Title>
          <ToggleListItem.Description>
            System will record logs on export
          </ToggleListItem.Description>
        </ToggleListItem>

        <ScopedConditionalContent permittedRoleTitles={['Admin']}>
          <ToggleListItem
            boxProps={{ marginBottom: 'none' }}
            // @ts-expect-error TS2345
            onClick={() => confirmAction(bulkImageExportPayload)}
            // @ts-expect-error TS2322
            toggleValue={batched_image_export_enabled}
          >
            <ToggleListItem.Title>Batch Image Export</ToggleListItem.Title>
            <ToggleListItem.Description>
              Images wil be exported in batches rather than individually
            </ToggleListItem.Description>
          </ToggleListItem>
        </ScopedConditionalContent>
      </Form>
    </DashboardModule>
  )
}

export default PortalSettings
